import apiClient from '../utils/apiClient';

/**
 * User API Services (quản lý người dùng/nhân viên ở lớp CMS)
 * Theo yêu cầu: dùng PUT `/users/:id/approve`, đổi role, đổi password, cập nhật thông tin user
 */
export const userAPI = {
  /** Danh sách user (nếu cần, tùy backend) */
  getUsers: async (params = {}) => {
    const { search, status, page = 1, limit = 10 } = params;
    return await apiClient.get({
      url: '/auth/users',
      params: { search, status, page, limit },
    });
  },

  /** Approve user */
  approveUser: async (userId) => {
    return await apiClient.put({
      url: `/auth/users/${userId}/approve`,
    });
  },

  /**
   * #024038 — Từ chối hồ sơ ứng tuyển kèm lý do. Máy chủ ghi `rejection_reason`, đổi trạng thái
   * REJECTED và báo ứng viên qua Zalo. Ứng viên vẫn nộp lại được hồ sơ mới bằng số đó.
   */
  rejectUser: async (userId, reason) => {
    return await apiClient.put({
      url: `/auth/users/${userId}/reject`,
      data: { reason },
    });
  },

  /**
   * #024038 — Gửi lại mật mã đăng nhập lần đầu qua Zalo. Mật mã cũ mất hiệu lực ngay.
   * Chỉ dùng được khi nhân viên CHƯA đổi sang mật khẩu riêng.
   */
  resendPasscode: async (userId) => {
    return await apiClient.post({
      url: `/auth/users/${userId}/resend-passcode`,
    });
  },

  /** Đổi role user */
  updateUserRole: async (userId, role) => {
    return await apiClient.put({
      url: `/auth/users/${userId}/role`,
      data: { role },
    });
  },

  /** Admin đổi password cho user */
  changePasswordByAdmin: async (userId, newPassword) => {
    return await apiClient.put({
      url: `/auth/users/${userId}/password`,
      data: { password: newPassword },
    });
  },

  /** Cập nhật thông tin user */
  updateUser: async (userId, payload) => {
    return await apiClient.put({
      url: `/auth/users/${userId}`,
      data: payload,
    });
  },
};


